import React, { useState, useRef } from "react";
import * as XLSX from "xlsx";
// import Popover from "@mui/material/Popover";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
// import DialogContentText from "@mui/material/DialogContentText";
// import InfoIcon from "@mui/icons-material/Info";
import DialogTitle from "@mui/material/DialogTitle";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Button from "@mui/material/Button";
import { Alert, AlertTitle, Tooltip } from "@mui/material";
import Paper from "@mui/material/Paper";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  CircularProgress
} from "@mui/material";

const BulkUser = () => {
  const [loading, setLoading] = useState(false); // Add loading state
  const fileInputRef = useRef(null);
  const [state, setState] = useState({
    data: [],
    column1: "",
    column2: "",
    column3: "",
    column4: "",
    column5: "",
    errorMessage: "",
  });

  // console.log(state);

  const [handle, setHandle] = React.useState(false);
  const [handlenullvalue, setHandleNullValue] = React.useState(false);
  const [handleemail, setHandleEmail] = React.useState(false);
  const [validationerror, setvalidationError] = React.useState(false);

  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [open3, setOpen3] = React.useState(false);
  const [open4, setOpen4] = React.useState(false);
  const [dbdata, setDbData] = React.useState([]);
  const [errmsg, setErrMsg] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // Reset all state variables
    setState({
      data: [],
      column1: "",
      column2: "",
      column3: "",
      column4: "",
      column5: "",
      errorMessage: "",
    });
    setHandle(false);
    setHandleNullValue(false);
    setHandleEmail(false);
    setvalidationError(false);
    setDbData([]);
    setErrMsg("");
    // Clear file input
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleClose2 = () => {
    setOpen2(false);
    setOpen(false);
    window.location.reload();
  };

  const handleClose3 = () => {
    setOpen2(false);
    setOpen(false);
    setOpen3(false);
    setOpen4(false);

    setHandle(false);
    setHandleNullValue(false);
    setvalidationError(false);
    setHandleEmail(false);
    // window.location.reload();
  };

  const handleClose4 = () => {
    setOpen2(false);
    setOpen(false);
    setOpen3(false);
    setOpen4(false);

    setHandle(false);
    setHandleNullValue(false);
    setvalidationError(false);
    setHandleEmail(false);
    // window.location.reload();
  };

  const [anchorEl, setAnchorEl] = React.useState(null);

  // const handleClick1 = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose1 = () => {
  //   setAnchorEl(null);
  // };

  const open1 = Boolean(anchorEl);
  const id = open1 ? "simple-popover" : undefined;

  const validateEmail = (email) => {
    // Regular expression for validating email addresses
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmitClick = async (e) => {
    try {
      setLoading(true); // Start loading
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/createmultipleuser/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify(state.data),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const data = await response.json();
      const messageValues = [];
  
      Object.entries(data.message).forEach(([responseKey, responseValue]) => {
        messageValues.push(responseValue.message);
      });
      // console.log("---message values---", messageValues);
      setDbData(messageValues);
      setOpen2(true); // Show success modal
    } catch (error) {
      console.error(error);
      setState({ errorMessage: "Something Went Wrong" });
      setErrorOpen(true); // Show error modal instead
    } finally {
      setLoading(false); // Stop loading regardless of success/failure
    }
    
  };

  const handleFile = (file) => {
    // let count = 0;
    /* Boilerplate to set up FileReader */
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;
    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, { type: rABS ? "binary" : "array" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      const column1 = ws.A1 ? ws.A1.v : null;
      const column2 = ws.B1 ? ws.B1.v : null;
      const column3 = ws.C1 ? ws.C1.v : null;
      const column4 = ws.D1 ? ws.D1.v : null;
      const column5 = ws.E1 ? ws.E1.v : null;

      if (column1 == null || column2 == null || column3 == null || column4 == null || column5 == null ) {
        setHandle(true);
        return true;
      }

      if (column1 != "Name" || column2 != "LogInEmailId" || column3 != "Password" || column4 != "Group" || column5 != "Action" ) {
        setHandle(true);
        return true;
      } else {
        /* Convert array of arrays */
        const data = XLSX.utils.sheet_to_json(ws);
        
        let mail_id = ""
        const invalidEmails = data.filter((row) => {
          mail_id = row.LogInEmailId;
          return !validateEmail(row.LogInEmailId);

        });

        if (invalidEmails.length > 0) {
          const errorMessage = "email id is invalid - " + mail_id;
          setErrMsg(errorMessage);
          setOpen(false);
          setOpen3(false);
          setHandleNullValue(false);
          setOpen4(true);
          setHandleEmail(true);
          setvalidationError(true);
          return;
        }

        const hasEmptyValues = data.some((row) => {
          return !row.Name || !row.LogInEmailId || !row.Password || !row.Group || !row.Action;
        });

        if (hasEmptyValues) {
          // Handle error for empty or null values
          // For example:
          console.error("One or more columns have empty or null values.");
          setHandleNullValue(true);
          setOpen(false);
          setOpen3(true);
          setvalidationError(true);
          return;
        }

        /* Update state */
        setState({ data: data, column1: column1, column2: column2, column3: column3, column4: column4, column5: column5 });
        setHandle(false);
        setHandleNullValue(false);
        setvalidationError(false);
      }
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  };

  return (
    <>
      <Tooltip title="Upload" arrow>
        <Button
          variant="contained"
          style={{ marginLeft: "20px" }}
          onClick={handleClickOpen}
          startIcon={<CloudUploadIcon />}
          sx={{ borderRadius: '50px', px: 3, py: 1 }}
          aria-label="Upload"
        >
          Upload
        </Button>
      </Tooltip>
      <div className="App">
      <Dialog
        fullWidth
        open={open}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
            handleClose();
          }
        }}
        aria-labelledby="form-dialog-title"
      >

          {handle ? (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              File header name is not valid.
            </Alert>
          ) : (
            ""
          )}
          {validationerror ? (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {state.errorMessage}
            </Alert>
          ) : (
            ""
          )}
          <DialogTitle id="form-dialog-title">
            Example: User.csv, User.xlsx, User.xls
          </DialogTitle>

          <DialogContent>
            <DragDropFile handleFile={handleFile}>
              <div className="row">
                <div className="col-xs-12">
                  <DataInput handleFile={handleFile} ref={fileInputRef} />
                </div>
              </div>
              <br />
              {!handle && !validationerror && state.data.length > 0 ? (
                <div className="row">
                  <div className="col-xs-12">
                    <OutTable data={state.data} />
                  </div>
                </div>
              ) : (
                ""
              )}
              <br />
              <br />
            </DragDropFile>
          </DialogContent>
          <DialogActions>
            <Tooltip title="Cancel" arrow>
              <span>
                <Button onClick={handleClose} color="primary" variant="contained" disabled={loading} sx={{ borderRadius: '50px', px: 3, py: 1 }} aria-label="Cancel">
                  Cancel
                </Button>
              </span>
            </Tooltip>

            <Tooltip title="Upload" arrow>
              <span>
                <Button
                  onClick={handleSubmitClick}
                  color="primary"
                  variant="contained"
                  disabled={
                loading ||
                (state.column1 === "Name" && 
                 state.column2 === "LogInEmailId" && 
                 state.column3 === "Password" && 
                 state.column4 === "Group" && 
                 state.column5 === "Action"
                  ? false
                  : true)
                  }
                  sx={{ borderRadius: '50px', px: 3, py: 1 }}
                  aria-label="Confirm Upload"
                >
              {loading ? (
              <>
                <CircularProgress size={24} color="inherit" style={{ marginRight: 8 }} />
                Processing...
              </>
            ) : (
              "OK"
            )}
                </Button>
              </span>
            </Tooltip>
          </DialogActions>
        </Dialog>
        

        <Dialog
          open={open2}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
              handleClose2();
            }
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle id="form-dialog-title">
            User Import Results
          </DialogTitle>
          <DialogContent>
            <TableContainer component={Paper} style={{ maxHeight: '400px', overflow: 'auto' }}>
              <Table stickyHeader size="small" aria-label="user import results">
                <TableHead>
                  <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Message</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dbdata.map((data2, index) => {
                    // Parse the message to extract components
                    const parts = data2.split('->').map(part => part.trim());
                    const status = parts[0].split('-')[1].trim();
                    const email = parts[1].split('"')[1];
                    const message = parts[1].split('"')[2].trim();
                    
                    return (
                      <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>
                          <span style={{ 
                            color: status === 'Failed' ? '#f44336' : '#4caf50',
                            fontWeight: 'bold'
                          }}>
                            {status}
                          </span>
                        </TableCell>
                        <TableCell>{email}</TableCell>
                        <TableCell>{message}</TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose2} color="primary" variant="contained">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        
        <Dialog fullWidth open={open3} onClose={handleClose3} aria-labelledby="form-dialog-title">
          {handlenullvalue ? (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              Please check the given data. Some data cells and rows contain empty or null values.
            </Alert>
          ) : (
            ""
          )}
          <DialogActions>
            <Tooltip title="OK" arrow>
              <Button
                onClick={handleClose3}
                color="primary"
                variant="contained"
                sx={{ borderRadius: '50px', px: 3, py: 1 }}
              >
                Ok
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
        <Dialog fullWidth open={open4} onClose={handleClose4} aria-labelledby="form-dialog-title">
          {handleemail ? (
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              Please check this {errmsg}.
            </Alert>
          ) : (
            ""
          )}
          <DialogActions>
            <Tooltip title="OK" arrow>
              <Button
                onClick={handleClose4}
                color="primary"
                variant="contained"
                sx={{ borderRadius: '50px', px: 3, py: 1 }}
              >
                Ok
              </Button>
            </Tooltip>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

const DragDropFile = (props) => {
  const { handleFile } = props;
  const suppress = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();
  };

  const onDrop = (evt) => {
    evt.stopPropagation();
    evt.preventDefault();

    const files = evt.dataTransfer.files;
    if (files && files[0]) handleFile(files[0]);
  };
  return (
    <div onDrop={onDrop} onDragEnter={suppress} onDragOver={suppress}>
      {props.children}
    </div>
  );
};

const DataInput = React.forwardRef((props, ref) => {
  const { handleFile } = props;
  const handleChange = (e) => {
    const files = e.target.files;
    if (files && files[0]) handleFile(files[0]);
  };

  const SheetJSFT = [
    "xlsx",
    "xlsb",
    "xlsm",
    "xls",
    "csv",
  ].map(function (x) {
    return "." + x;
  })
    .join(",");

  return (
    <form className="form-inline">
      <div className="form-group">
        <input
          type="file"
          className="form-control"
          id="file"
          accept={SheetJSFT}
          onChange={handleChange}
          style={{ display: "block", margin: "10px auto" }}
          ref={ref}
        />
      </div>
    </form>
  );
});

const OutTable = (props) => {
  const { data } = props;
  return (
    <TableContainer component={Paper} style={{ overflowX: "auto" }}>
      <Table aria-label="simple table">
        <TableHead style={{ backgroundColor: "#06396c" }}>
          <TableRow>
            <TableCell style={{ color: "#ffffff" }} align="center">ID</TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">Name</TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">LogInEmailId</TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">Password</TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">Group</TableCell>
            <TableCell style={{ color: "#ffffff" }} align="center">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => (
            <TableRow>
              <TableCell align="center" key={r.__rowNum__}>
                {r.__rowNum__}
              </TableCell>
              <TableCell align="center" key={r.Name}>
                {r.Name}
              </TableCell>
              <TableCell align="center" key={r.LogInEmailId}>
                {r.LogInEmailId}
              </TableCell>
              <TableCell align="center" key={r.Password}>
                {r.Password}
              </TableCell>
              <TableCell align="center" key={r.Group}>
                {r.Group}
              </TableCell>
              <TableCell align="center" key={r.Action}>
                {r.Action}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BulkUser;
